export enum TourActionTypes {
  MARK_WIZARD_STEP_SEEN = '@tour/MARK_WIZARD_STEP_SEEN',
  DISMISS_WIZARD_TOUR = '@tour/DISMISS_WIZARD_TOUR',
  MARK_DASHBOARD_TOUR_SEEN = '@tour/MARK_DASHBOARD_TOUR_SEEN',
  DISMISS_DASHBOARD_TOUR = '@tour/DISMISS_DASHBOARD_TOUR',
  MARK_RESTART_CYCLE_TOUR_SEEN = '@tour/MARK_RESTART_CYCLE_TOUR_SEEN',
  MARK_TIMER_CARD_TOUR_SEEN = '@tour/MARK_TIMER_CARD_TOUR_SEEN',
  MARK_TIMER_FULLSCREEN_TOUR_SEEN = '@tour/MARK_TIMER_FULLSCREEN_TOUR_SEEN',
}

export interface ITourWizardState {
  step_1: boolean
  step_2: boolean
  step_3: boolean
  step_4: boolean
  dismissed: boolean
}

export interface ITourDashboardState {
  seen: boolean
  dismissed: boolean
  restartCycleTourSeen: boolean
  timerCardTourSeen: boolean
  timerFullScreenTourSeen: boolean
}

export interface ITourState {
  wizard: ITourWizardState
  dashboard: ITourDashboardState
}

export interface IMarkWizardStepSeen {
  type: typeof TourActionTypes.MARK_WIZARD_STEP_SEEN
  payload: 1 | 2 | 3 | 4
}

export interface IDismissWizardTour {
  type: typeof TourActionTypes.DISMISS_WIZARD_TOUR
}

export interface IMarkDashboardTourSeen {
  type: typeof TourActionTypes.MARK_DASHBOARD_TOUR_SEEN
}

export interface IDismissDashboardTour {
  type: typeof TourActionTypes.DISMISS_DASHBOARD_TOUR
}

export interface IMarkRestartCycleTourSeen {
  type: typeof TourActionTypes.MARK_RESTART_CYCLE_TOUR_SEEN
}

export interface IMarkTimerCardTourSeen {
  type: typeof TourActionTypes.MARK_TIMER_CARD_TOUR_SEEN
}

export interface IMarkTimerFullScreenTourSeen {
  type: typeof TourActionTypes.MARK_TIMER_FULLSCREEN_TOUR_SEEN
}

export type TourActions =
  | IMarkWizardStepSeen
  | IDismissWizardTour
  | IMarkDashboardTourSeen
  | IDismissDashboardTour
  | IMarkRestartCycleTourSeen
  | IMarkTimerCardTourSeen
  | IMarkTimerFullScreenTourSeen
